























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProductListControl extends Vue {

  @Prop({ type: String, default: 'text-right' }) protected align!: string;

  protected openNewProductDlg() {
    this.$emit('openNewProductDlg');
  }


}

